import { PATH_NAME } from "../configs/pathName";
import { ContactFormData } from "../models/IContactForm";
import axiosInstance from "./axiosInstance";

export const submitContactForm = async (data: ContactFormData) => {
    
      const response = await axiosInstance.post(PATH_NAME.API_CONTACT_FORM, data);
      return response.data;
  };